/* MZ Foods theme — storefront behaviour. Cart uses the Shopify Ajax Cart API. */
(function () {
  const MZ = window.MZ || {}, C = MZ.config || {};
  const ROOT = MZ.root || '/';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const rs = cents => 'Rs ' + Math.round(cents / 100).toLocaleString('en-US');
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const wa = t => 'https://wa.me/' + C.whatsapp + '?text=' + encodeURIComponent(t);
  const HELLO = 'Assalam o Alaikum MZ Foods!';
  const WA_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" width="26" height="26"><path d="M12 2a10 10 0 00-8.6 15.1L2 22l5-1.3A10 10 0 1012 2zm0 18.2a8.2 8.2 0 01-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1112 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 01-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 00-.7.3 3 3 0 00-.9 2.2 5.2 5.2 0 001.1 2.7 11.8 11.8 0 004.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 001.8-1.2 2.2 2.2 0 00.1-1.3c0-.1-.2-.2-.5-.3z"/></svg>';
  const FREE = (C.free_over || 0) * 100, FEE = (C.delivery_fee || 0) * 100;
  const thumbUrl = src => { try { const u = new URL(src, location.href); u.searchParams.set('width', '160'); return u.href; } catch (e) { return src; } };

  /* ---------------- cart (Shopify Ajax API) ---------------- */
  const api = (path, body) => fetch(ROOT + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
    .then(r => r.json().then(j => { if (!r.ok) throw j; return j; }));
  const WAS = {}, SEEN = {}, PACK = {};  // variant id -> compare_at_price (cents); handles fetched; handle -> pack variants
  const lineWas = i => (WAS[i.variant_id] || 0) > i.final_price ? WAS[i.variant_id] * i.quantity : 0;
  // cart.js lines carry no compare_at_price or sibling variants, so read each product's .js once
  const loadInfo = c => Promise.all([...new Set(c.items.map(i => i.handle))].filter(h => !(h in SEEN)).map(h => (SEEN[h] = api('products/' + h + '.js').then(p => {
    p.variants.forEach(v => { WAS[v.id] = v.compare_at_price || 0; });
    const o = (p.options || [])[0];
    if (o && /^pack$/i.test(o.name || o)) PACK[h] = p.variants.filter(v => v.available).map(v => ({ id: v.id, n: parseInt(v.title, 10) || 0, price: v.price })).filter(x => x.n > 0);
  }).catch(() => {}))));
  // cheapest mix of packs (1/2/3 jars ...) for exactly n units -> { cost, qty: { variantId: count } }
  const bestPacks = (packs, n) => {
    const cost = [0], pick = [null];
    for (let i = 1; i <= n; i++) { cost[i] = Infinity; packs.forEach(p => { if (p.n <= i && cost[i - p.n] + p.price < cost[i]) { cost[i] = cost[i - p.n] + p.price; pick[i] = p; } }); }
    const qty = {}; for (let i = n; i > 0 && pick[i]; i -= pick[i].n) qty[pick[i].id] = (qty[pick[i].id] || 0) + 1;
    return { cost: cost[n], qty };
  };
  const Cart = {
    data: null,
    refresh() {
      let changed = false;
      return api('cart.js').then(c => loadInfo(c).then(() => this.combine(c)).then(ch => { changed = ch; return ch ? api('cart.js') : c; }))
        .then(c => { this.data = c; this.render(); if (changed && document.body.classList.contains('t-cart')) location.reload(); return c; });
    },
    // Jars added one by one (or via +) are swapped for the cheapest pack variants, so pack discounts always apply
    combine(c) {
      const updates = {}; let before = 0, after = 0;
      Object.keys(PACK).forEach(h => {
        const packs = PACK[h], lines = c.items.filter(i => i.handle === h); if (!lines.length || !packs.length) return;
        const size = id => (packs.find(p => p.id === id) || {}).n || 0;
        const units = lines.reduce((t, i) => t + size(i.variant_id) * i.quantity, 0); if (!units) return;
        const best = bestPacks(packs, units); if (best.cost === Infinity) return;
        const cur = lines.reduce((t, i) => t + i.final_line_price, 0);
        packs.forEach(p => { const have = lines.filter(i => i.variant_id === p.id).reduce((t, i) => t + i.quantity, 0), want = best.qty[p.id] || 0; if (have !== want) updates[p.id] = want; });
        if (Object.keys(updates).length) { before += cur; after += best.cost; }
      });
      if (!Object.keys(updates).length) return Promise.resolve(false);
      return api('cart/update.js', { updates }).then(() => { if (after < before) toast('Pack price applied: you save ' + rs(before - after)); return true; }).catch(() => false);
    },
    add(id, quantity = 1) {
      return api('cart/add.js', { items: [{ id: +id, quantity }] })
        .then(() => this.refresh()).then(() => open('cart'))
        .catch(e => toast((e && (e.description || e.message)) || 'Could not add to cart. Please try again.'));
    },
    change(key, quantity) { return api('cart/change.js', { id: key, quantity }).then(() => this.refresh()).catch(() => this.refresh()); },  // change.js total_price includes estimated delivery; cart.js does not
    text() {
      const c = this.data;
      return HELLO + ' I want to order:\n' + c.items.map(i => `• ${i.quantity} × ${i.product_title}${i.variant_title ? ' (' + i.variant_title + ')' : ''} — ${rs(i.final_line_price)}`).join('\n') +
        `\nTotal: ${rs(c.total_price)}\nName:\nCity:\nAddress:`;
    },
    render() {
      const c = this.data; if (!c) return;
      $$('.count').forEach(el => { el.textContent = c.item_count; el.dataset.n = c.item_count; });
      const body = $('#cart-body'), foot = $('#cart-foot');
      if (!body) return;
      if (!c.item_count) {
        body.innerHTML = `<div class="empty"><p>Your cart is empty.</p><a class="btn primary block" href="${ROOT}collections/all">Start shopping</a></div>`;
        foot.hidden = true; return;
      }
      const sub = c.total_price, left = Math.max(0, FREE - sub), fee = left ? FEE : 0;
      const saved = c.items.reduce((t, i) => { const w = lineWas(i); return t + (w ? w - i.final_line_price : 0); }, 0);
      body.innerHTML = `<div class="goal">${left ? `Add <b>${rs(left)}</b> more for <b>free delivery</b>` : '<b>You get free delivery!</b>'}<div class="bar"><i style="width:${Math.min(100, sub / FREE * 100)}%"></i></div></div>
        <div class="cart-lines">${c.items.map(i => `<div class="line">
          <a class="thumb" href="${esc(i.url)}">${i.image ? `<img src="${esc(thumbUrl(i.image))}" alt="" width="80" height="80">` : ''}</a>
          <div><b>${esc(i.product_title)}</b><span class="v">${esc(i.variant_title || i.product_type || '')}</span>
            <div class="qty"><button aria-label="Decrease" data-set="${i.key}:${i.quantity - 1}">−</button><span>${i.quantity}</span><button aria-label="Increase" data-set="${i.key}:${i.quantity + 1}">+</button></div></div>
          <div class="r">${lineWas(i) ? `<s class="was">${rs(lineWas(i))}</s>` : ''}<b>${rs(i.final_line_price)}</b>${lineWas(i) ? `<span class="saved">Save ${rs(lineWas(i) - i.final_line_price)}</span>` : ''}<button class="rm" data-set="${i.key}:0">Remove</button></div></div>`).join('')}</div>`;
      foot.hidden = false;
      foot.innerHTML = `${saved ? `<div class="tot saved"><span>You save</span><span>${rs(saved)}</span></div>` : ''}<div class="tot"><span>Subtotal</span><span>${rs(sub)}</span></div>
        <div class="tot"><span>Delivery</span><span>${fee ? rs(fee) : 'Free'}</span></div>
        <div class="tot big"><span>Estimated total</span><span>${rs(sub + fee)}</span></div>
        <div class="row2"><a class="wa-sq" target="_blank" rel="noopener" href="${wa(this.text())}" aria-label="Order on WhatsApp">${WA_SVG}</a>
        <a class="btn primary block" href="${ROOT}checkout">Checkout · Cash on Delivery</a></div>
        <p class="note">Pay cash when your parcel arrives.</p>`;
    }
  };

  /* ---------------- overlays ---------------- */
  function open(which) {
    closeAll(false);
    const el = $('#' + (which === 'search' ? 'menu' : which));
    if (!el) return;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); $('#scrim').classList.add('open');
    document.body.style.overflow = 'hidden';
    if (which === 'search') setTimeout(() => $('#q').focus(), 260);
  }
  function closeAll(restore = true) {
    $$('.menu, .cart').forEach(el => { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); });
    const s = $('#scrim'); if (s) s.classList.remove('open');
    if (restore) document.body.style.overflow = '';
  }
  function toast(msg) {
    let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show'); clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2800);
  }

  document.addEventListener('click', e => {
    const pk = e.target.closest('[data-pick]');
    if (pk) {
      const card = pk.closest('.card'), was = +pk.dataset.was, price = +pk.dataset.price;
      $$('[data-pick]', card).forEach(x => { x.classList.toggle('on', x === pk); x.setAttribute('aria-checked', String(x === pk)); });
      $('[data-cp]', card).textContent = rs(price);
      const w = $('[data-cw]', card); w.hidden = !(was > price); w.textContent = was > price ? rs(was) : '';
      const b = $('[data-add]', card); if (b) b.dataset.add = pk.dataset.pick;
      return;
    }
    const t = e.target.closest('[data-open],[data-close],[data-add],[data-set],#scrim');
    if (!t) return;
    if (t.dataset.open) { if (t.dataset.open === 'cart' && document.body.classList.contains('t-cart')) return; e.preventDefault(); open(t.dataset.open); }
    else if ('close' in t.dataset || t.id === 'scrim') closeAll();
    else if (t.dataset.add) { e.preventDefault(); t.classList.add('is-busy'); Cart.add(t.dataset.add).finally(() => t.classList.remove('is-busy')); }
    else if (t.dataset.set) { const i = t.dataset.set.lastIndexOf(':'); Cart.change(t.dataset.set.slice(0, i), +t.dataset.set.slice(i + 1)); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  const sheet = $('#cart');
  if (sheet) {
    let y0 = null;
    sheet.addEventListener('touchstart', e => { y0 = e.target.closest('.cart-lines') ? null : e.touches[0].clientY; }, { passive: true });
    sheet.addEventListener('touchend', e => { if (y0 !== null && e.changedTouches[0].clientY - y0 > 70) closeAll(); y0 = null; }, { passive: true });
  }

  /* ---------------- announcement ---------------- */
  const msgs = ['Cash on Delivery all over Pakistan', `Free delivery over ${rs(FREE)}`, `Order on WhatsApp · ${C.whatsapp_display}`];
  let ai = 0; const ann = $('#ann');
  if (ann) setInterval(() => { ann.style.opacity = 0; setTimeout(() => { ai = (ai + 1) % msgs.length; ann.textContent = msgs[ai]; ann.style.opacity = 1; }, 350); }, 3500);

  /* ---------------- read more (SEO text) ---------------- */
  $$('.readmore').forEach(el => {
    if (el.scrollHeight <= 170) { el.classList.add('open'); return; }
    const b = document.createElement('button'); b.className = 'rm-btn'; b.textContent = 'Read more'; b.setAttribute('aria-expanded', 'false');
    b.onclick = () => { const o = el.classList.toggle('open'); b.textContent = o ? 'Read less' : 'Read more'; b.setAttribute('aria-expanded', String(o)); };
    el.after(b);
  });

  /* ---------------- product page ---------------- */
  const pdp = $('.pdp');
  if (pdp) {
    const name = pdp.dataset.name;
    let variants = [];
    try { variants = JSON.parse($('#pdp-variants').textContent); } catch (e) {}
    let v = variants.find(x => x.id == pdp.dataset.variant) || variants[0], qty = 1;
    const label = () => v && v.title !== 'Default Title' ? `${name} ${v.title}` : name;
    const packs = 'pack' in pdp.dataset ? variants.filter(x => x.available).map(x => ({ id: x.id, n: parseInt(x.title, 10) || 0, price: x.price })).filter(x => x.n > 0) : [];
    // pack products: 2 x "1 Jar" is charged as the cheaper "2 Jars" pack once in the cart, so show that total here too
    const total = () => { const n = packs.length && (parseInt(v.title, 10) || 0) * qty; return n ? bestPacks(packs, n).cost : v.price * qty; };
    function sync() {
      const q = $('#qty'); if (q) q.textContent = qty;
      if (v) {
        $('#pdp-price').textContent = rs(v.price);
        const was = $('#pdp-was'), save = $('#pdp-save'), off = v.compare_at_price > v.price;
        if (was) { was.hidden = !off; was.textContent = off ? rs(v.compare_at_price) : ''; }
        if (save) { save.hidden = !off; save.textContent = off ? 'Save ' + rs(v.compare_at_price - v.price) : ''; }
        $$('[data-total]').forEach(el => el.textContent = rs(total()));
      }
      const link = wa(`${HELLO} I want to order ${qty} × ${label()}${v ? ' (' + rs(total()) + ')' : ''}. Cash on Delivery please.\nName:\nCity:\nAddress:`);
      $$('[data-wa]').forEach(a => a.href = link);
    }
    pdp.addEventListener('click', e => {
      const s = e.target.closest('.size'), q = e.target.closest('[data-qty]'), b = e.target.closest('[data-buy]');
      if (s) {
        v = variants.find(x => x.id == s.dataset.id) || v;
        $$('.size').forEach(x => { x.classList.toggle('on', x === s); x.setAttribute('aria-checked', String(x === s)); });
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
        sync();
      }
      if (q) { qty = Math.max(1, qty + +q.dataset.qty); sync(); }
      if (b && v) Cart.add(v.id, qty);
    });
    const bb = $('#buybar [data-buy]'); if (bb) bb.addEventListener('click', () => v && Cart.add(v.id, qty));
    const track = $('#track');
    if (track) track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      $$('.dots i').forEach((d, j) => d.classList.toggle('on', i === j));
    }, { passive: true });
    sync();
  }

  /* ---------------- bundle deals filters ---------------- */
  const dl = $('#deal-list');
  if (dl) {
    const params = new URLSearchParams(location.search);
    let type = 'all', withH = params.get('with'), line = params.get('line');
    const LINE_TYPES = { zen: ['zen-ispaghol', 'honey-wellness'], ispaghol: ['zen-ispaghol', 'honey-wellness'], honey: ['honey', 'honey-wellness'] };
    function apply() {
      let shown = 0;
      $$('#deal-list > article').forEach(a => {
        const okType = type === 'all' || a.dataset.type === type;
        const okWith = !withH || (a.dataset.with || '').split(' ').includes(withH);
        const okLine = !line || !LINE_TYPES[line] || LINE_TYPES[line].includes(a.dataset.type);
        const ok = okType && okWith && okLine; a.hidden = !ok; if (ok) shown++;
      });
      $('#deal-empty').hidden = shown > 0;
      $$('#deal-chips .chip').forEach(c => c.classList.toggle('on', c.dataset.type === type));
      const note = $('#with-note');
      if (withH || (line && LINE_TYPES[line])) { note.hidden = false; note.innerHTML = `<span>Showing ${shown} matching deals</span><button type="button">Show all</button>`; }
      else note.hidden = true;
    }
    $('#deal-chips').addEventListener('click', e => { const c = e.target.closest('.chip'); if (c) { type = c.dataset.type; apply(); } });
    $('#with-note').addEventListener('click', e => { if (e.target.tagName === 'BUTTON') { withH = null; line = null; history.replaceState(null, '', location.pathname); apply(); } });
    apply();
  }

  /* ---------------- all products: jump chips ---------------- */
  $$('[data-jump]').forEach(a => a.addEventListener('click', e => {
    const s = $(`.all-sec[data-line="${a.dataset.jump}"]`); if (s) { e.preventDefault(); s.scrollIntoView({ behavior: 'smooth' }); }
  }));

  /* ---------------- home hero slider ---------------- */
  const hsTrack = $('#hs-track');
  if (hsTrack) {
    const slides = $$('.hs-slide', hsTrack), dots = $$('.hs-dots button');
    let cur = 0, timer = null;
    const go = i => hsTrack.scrollTo({ left: (i % slides.length) * hsTrack.clientWidth });
    const mark = () => { cur = Math.round(hsTrack.scrollLeft / hsTrack.clientWidth); dots.forEach((d, i) => d.setAttribute('aria-selected', i === cur ? 'true' : 'false')); };
    const stop = () => { clearInterval(timer); timer = null; };
    hsTrack.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => { stop(); go(i); }));
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(ev => hsTrack.addEventListener(ev, stop, { passive: true }));
    const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && slides.length > 1) timer = setInterval(() => { if (!document.hidden) go(cur + 1); }, 3000);
  }

  Cart.refresh().catch(() => {});
  window.MZCart = Cart;
})();
